<template>
  <div>
    <div class="header">
      <header-search @searchNewWord='searchNewWord'></header-search>
    </div>
    <div class="back_prev" @click="backPrev" ref="back_prev">
      <img src="../static/img/back_prev.png" alt="">
    </div>
    <div class="press_media_detail">
      <div class="detail_content">
        <!--信息来源-->
        <div class="content_source">
          <div class="source_desc">
            <div class="desc_top" v-if="searchType=='medias'">
              <span class="source_title">
                {{this.contentDetail.mc}}
              </span>
            </div>
            <div class="rep_desc_top" v-if="searchType=='reporters'">
              <div class="rep_info_img">
                <img src="../static/img/avatar.png" alt="">
              </div>
              <div class="rep_info_content" v-if="reporterDetail.ssmt">
                <span class="rep_info_name">{{reporterDetail.xm}}</span>
                <span class="rep_info_role">{{reporterDetail.ssmt.zw}}</span>
              </div>
            </div>
            <div class="desc_media">
              <span class="media_address" v-if="searchType == 'medias' && contentDetail.ssdy">
                <img src="../static/img/media_addr.png" alt="">&nbsp;
                媒体地址：<span>{{contentDetail.ssdy}}</span>
              </span>
              <span class="media_address" v-if="searchType == 'reporters' && reporterDetail.ssmt">
                <img src="../static/img/media_addr.png" alt="">&nbsp;
                所在媒体：<span>{{reporterDetail.ssmt.mc}}</span>
              </span>
              <span class="media_type" v-if="searchType == 'medias' && contentDetail.mtjb">
                <img src="../static/img/media_type.png" alt="">&nbsp;
                媒体来源：<span>{{contentDetail.mtjb}}</span>
              </span>
            </div>
          </div>
          <div class="source_number" v-if="contentDetail.tj">
            <!--{{this.contentDetail.tj.zyzs}}-->
            文章总数<span>&nbsp;{{contentDetail.tj.wzzs}}&nbsp;</span>篇
          </div>
          <div class="source_number" v-if="reporterDetail.gjzs">
            <!--{{this.contentDetail.tj.zyzs}}-->
            文章总数<span>&nbsp;{{reporterDetail.gjzs}}&nbsp;</span>篇
          </div>
        </div>
        <div class="media_chart" v-if="searchType == 'medias'">
          <div class="chart">
            <!--资源类型图-->
            <div class="resource_type" id="resource_type">

            </div>
            <!--传播渠道图-->
            <div class="spread_channel" id="spread_channel">

            </div>
          </div>
        </div>

        <!--任职人员-->
        <div class="incumbent" v-if="searchType=='medias'">
          <div class="incumbent_number">
            <span class="incumbent_text">任职人员</span>
            <div class="incumbent_type">
              <el-radio-group v-model="tabPosition" class="btn_media_group">
                <el-radio-button label="全部">全部({{allList.total?allList.total:0}})</el-radio-button>
                <el-radio-button label="编辑">编辑({{editorList.total?editorList.total:0}})</el-radio-button>
                <el-radio-button label="记者">记者({{reporterList.total?reporterList.total:0}})</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="incumbent_info" ref="info_item">
            <div class="info_item" v-for="item in showList.dataList" :key="item.xm" @click="toPerson(item.xm)" >
              <div class="info_img">
                <img src="../static/img/avatar.png" alt="">
              </div>
              <div class="info_content">
                <span class="info_name">{{item.xm}}</span><br>
                <span class="info_role">{{item.ssmt.mc}}-{{item.ssmt.zw}}</span>
              </div>
            </div>
            <div class="search_page" ref="search_page" v-if="this.showList.total>10">
              <button @click="prevPage" class="btn_page" ref="prev_page" title="上一页">&lt;</button>&nbsp;&nbsp;&nbsp;
              <button @click="nextPage" class="btn_page" ref="next_page" title="下一页">&gt;</button>
            </div>
          </div>
          <div class="noData" v-if="!showList.total">暂无数据……</div>
        </div>
        <!--最新文章-->
        <div class="latest_article">
          <div class="article_desc">
            <span class="article_text">最新文章</span>
            <span class="article_more" @click="readMore()">查看更多&gt;</span>
          </div>
          <div class="article_list">
            <ul class="result_item" v-if="searchType == 'reporters'">
                  <li @click="selectItem(item)" v-for="(item,index) in contentList" :key="index">
                      <div class="item">
                        <span class="item_title" v-html="item.bt"></span>
                        <span v-if="item.lx.indexOf('文本') > -1" class="item_content" v-html="item.zhaiyao"></span>
                      </div>
                      <img v-if="item.lx.indexOf('图片') > -1 && index<5" class="item_img" v-for="(url, index) in item.urls" :key="index" :src="url" />
                      <div class="item_video_pic" v-if="item.lx.indexOf('视频') > -1 && item.thumbnail">
                        <div class="top__front"></div>
                        <img class="item_video" :src="item.thumbnail[0]" />
                        <img class="item_play" src="../static/img/play.png" />
                      </div>
                      <img v-if="item.lx.indexOf('音频') > -1" class="item_music" src="../static/img/mp3.png" />
                      <div class="item_detail">
                          <img src="../static/img/fbsj.png" /><span >发布时间：{{item.fbsj}} </span>
                          <img src="../static/img/fgmt.png"/><span v-if="item.fgmt">发稿来源：{{item.fgmt.mc}} </span><span v-else>发稿来源：{{item.fgly}} </span>
                          <img src="../static/img/lylx.png" /><span >来源类型：{{item.lyqd}} </span>
                      </div>
                  </li>
            </ul>
            <listView @select='getDetail' :dataList='dataList' v-if="dataList != []"></listView>
          </div>
          <no-data v-show="!dataList.length&&!contentList.length"></no-data>
        </div>
      </div>
      <div class="attach_info">
        <div class="attach_text">
          <span>媒体单位</span>
        </div>

        <div class="attach_content" v-if="searchType == 'medias'">
          <div class="attach_item" v-for="item in same_level_media" :key="item.id">
            <div class="attach_desc">
              <span class="attach_desc_text">{{item.mc}}</span>
            </div>
            <div class="attach_link">
              <div class="link_img">
                <img src="../static/img/link.png" alt="">
              </div>
              <span class="link_address"><a :href="item.sydz" :title="item.sydz" target="_blank">{{item.sydz}}</a></span>
            </div>
            <div class="attach_link">
              <div class="link_img">
                <img src="../static/img/link_address.png" alt="">
              </div>
              <span class="address">{{item.ssdy}}</span>
            </div>
          </div>
        </div>

        <div class="attach_content" v-if="searchType == 'reporters' && reporterDetail.ssmt">
          <div class="attach_item">
            <div class="attach_desc">
              <span class="attach_desc_text" v-if="reporterDetail.ssmt">{{reporterDetail.ssmt.mc}}</span>
            </div>
            <div class="attach_link">
              <div class="link_img">
                <img src="../static/img/link.png" alt="">
              </div>
              <span class="link_address" v-if="reporterDetail.ssmt"><a :href="reporterDetail.ssmt.sydz" :title="reporterDetail.ssmt.sydz" target="_blank">{{reporterDetail.ssmt.sydz}}</a></span>
            </div>
            <div class="attach_link">
              <div class="link_img">
                <img src="../static/img/link_address.png" alt="">
              </div>
              <span class="address" v-if='reporterDetail.ssmt'>{{reporterDetail.ssmt.ssdy}}</span>
            </div>
          </div>
        </div>
        <div class="noData" v-if="(searchType == 'medias'&&same_level_media&&!same_level_media.length) || (searchType == 'reporters' && !reporterDetail.ssmt)">暂无数据……</div>
      </div>

      <div class="attach_info" v-if="searchType=='reporters'">
        <div class="attach_text">
          <span v-if="reporterDetail.ssmt">同媒体下{{reporterDetail.ssmt.zw}}</span>
        </div>
        <div class="attach_reporter" @click="toReporter(item)" v-for="item in editorList.dataList" :key="item.xm" v-if="showEditor">
          <div class="attach_link_info" v-if="item.id!=reporterDetail.id">
            <div class="info_img">
              <img src="../static/img/avatar_big.png" />
            </div>
            <div class="info_content">
              <span class="info_content_name">{{item.xm}}</span><br/>
              <span class="info_content_role">{{item.ssmt.mc}}-{{item.ssmt.zw}}</span>
            </div>
          </div>
        </div>
        <div class="attach_reporter" @click="toReporter(item)" v-for="item in reporterList.dataList" :key="item.xm" v-if="!showEditor">
          <div class="attach_link_info" v-if="item.id!=reporterDetail.id">
            <div class="info_img">
              <img src="../static/img/avatar_big.png" />
            </div>
            <div class="info_content">
              <span class="info_content_name">{{item.xm}}</span><br/>
              <span class="info_content_role">{{item.ssmt.mc}}-{{item.ssmt.zw}}</span>
            </div>
          </div>
        </div>
        <div class="noData" v-if="(editorList.dataList&&!editorList.dataList.length) || (reporterList.dataList&&!reporterList.dataList.length)">暂无数据……</div>
      </div>
    </div>
    <div class="totop_icon" @click.stop="backTop" v-if="topShow">
      <img src="../static/img/backTop.png" alt=""/>
    </div>
  </div>
</template>

<script>
  import listView from './listView'
  import headerSearch from './headerSearch'
  import {_get} from '../api/index.js';
  import noData from './noData.vue'
  // 引入 ECharts 主模块
  var echarts = require('echarts/lib/echarts');
  // 引入柱状图和饼图
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/pie');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');

    export default {
        name: "pressMediaDetail",
      data() {
          return {
            tabPosition: '全部',
            searchType:'medias',
            contentDetail: [],
            same_level_media: [],
            reporterDetail:[],
            contentList:[],
            allList:[],
            editorList:[],
            reporterList:[],
            showList:[],
            dataList:[],
            count:0,
            allFrom:0,
            editorFrom:0,
            reporterFrom:0,
            allCount:0,
            editorCount:0,
            reporterCount:0,
            topShow:false
          }
      },
      components:{
        listView,
        headerSearch,
        noData
      },
      computed:{
        showEditor(){
          if(this.reporterDetail.ssmt && this.reporterDetail.ssmt.zw=='记者'){
            return false
          }else {
            return true
          }
        },
        
      },
      methods: {
        handleTop(){
          if(document.getElementById('app').scrollTop > 600){
            this.topShow = true
          }
          else{
            this.topShow = false
          }
          //console.log(document.getElementById('app').scrollTop)
        },
        backTop(){
          var body = document.getElementById('app');
          var speed = (body.scrollTop / 100) * 10
          var timer = setInterval(()=>{
          body.scrollTop  = body.scrollTop - speed
            if(body.scrollTop == 0 && body.scrollTop<speed){
              clearInterval(timer)
            }
          },20)
          //console.log(document.getElementById('app').scrollTop)
        },
        getContentDetail() {
          let id = this.$route.query.id
          let url = this.searchType + '/' +id
          //console.log(id)
          _get(url).then((res) => {
              //console.log(res)
              if(this.searchType === 'medias'){
                //console.log(res)
                //console.log(res.data.data.data)
                this.contentDetail = res.data.data.data
                this.same_level_media = res.data.data.same_level_media.dataList
                //console.log(this.same_level_media)
                this.getArticleList()
                this.getMediaInfo()
                this.drawBar()
                this.drawPie()
              }
              else{
                //console.log(res)
                this.reporterDetail = res.data.data
                this.$nextTick(function () {
                  this.getArticleList()
                  this.getMediaInfo()
                })
                //console.log(this.reporterDetail)
                // this.drawBar()
                // this.drawPie()
              }
            }).catch((res)=>{
              console.log(res)
            })
        },
        prevPage() {
          var id = ''
          if(this.searchType == 'medias'){
            id = this.$route.query.id
          }else{
            id = this.reporterDetail.ssmt.id
          }
          let urlAll = 'medias/'+id+'/reporters'
          let urlEditor = 'medias/'+id+'/type/reporters'
          let urlReporter = 'medias/'+id+'/type/reporters'
          
          if(this.tabPosition == '全部'){
            this.allCount--
            if(this.allCount < 0){
              this.allCount = 0
            }
            this.allFrom = 10*this.allCount
            var params = {
              from:this.allFrom,
              size:10
            }
            _get(urlAll,params).then(res =>{
              if(res){
                //console.log(res)
                this.allList = res.data.data
                this.showList = this.allList
                if(this.$refs.next_page.disabled == true){
                  this.$refs.next_page.disabled = false
                  this.$refs.next_page.style.cursor = 'pointer'
                  this.$refs.next_page.title = '下一页'
                }
                
                if(this.allFrom == 0){
                  this.$refs.prev_page.disabled = 'true'
                  this.$refs.prev_page.style.cursor = 'not-allowed'
                  this.$refs.prev_page.title = '前面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }else if(this.tabPosition == '编辑'){
            this.editorCount--
            if(this.editorCount < 0){
              this.editorCount = 0
            }
            this.editorFrom = 10*this.editorCount
            var params = {
              from:this.editorFrom,
              size:10,
              type:'编辑'
            }
            _get(urlEditor,params).then(res =>{
              if(res){
                this.editorList = res.data.data
                this.showList = this.editorList
                if(this.$refs.next_page.disabled == true){
                  this.$refs.next_page.disabled = false
                  this.$refs.next_page.style.cursor = 'pointer'
                  this.$refs.next_page.title = '下一页'
                }
                if(this.editorFrom == 0){
                  this.$refs.prev_page.disabled = 'true'
                  this.$refs.prev_page.style.cursor = 'not-allowed'
                  this.$refs.prev_page.title = '前面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }else{
            this.reporterCount--
            if(this.reporterCount < 0){
              this.reporterCount = 0
            }
            this.reporterFrom = 10*this.reporterCount
            var params = {
              from:this.reporterFrom,
              size:10,
              type:'记者'
            }
            _get(urlReporter,params).then(res =>{
              if(res){
                this.reporterList = res.data.data
                this.showList = this.reporterList
                if(this.$refs.next_page.disabled == true){
                  this.$refs.next_page.disabled = false
                  this.$refs.next_page.style.cursor = 'pointer'
                  this.$refs.next_page.title = '下一页'
                }
                if(this.reporterFrom == 0){
                  this.$refs.prev_page.disabled = 'true'
                  this.$refs.prev_page.style.cursor = 'not-allowed'
                  this.$refs.prev_page.title = '前面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }
        },
        nextPage() {
          var id = ''
          if(this.searchType == 'medias'){
            id = this.$route.query.id
          }else{
            id = this.reporterDetail.ssmt.id
          }
          let urlAll = 'medias/'+id+'/reporters'
          let urlEditor = 'medias/'+id+'/type/reporters'
          let urlReporter = 'medias/'+id+'/type/reporters'
          if(this.searchType.from == 0){
            this.$refs.prev_page.disabled = 'true'
            this.$refs.prev_page.style.cursor = 'not-allowed'
            this.$refs.prev_page.title = '前面没数据了……'
          }
          //debugger
          if(this.tabPosition == '全部'){
            this.allCount++
            this.allFrom = 10*this.allCount
            var params = {
              from:this.allFrom,
              size:10
            }
            _get(urlAll,params).then(res =>{
              //debugger
              //console.log(res)
              if(res){
                this.allList = res.data.data
                this.showList = this.allList
                if(this.$refs.prev_page.disabled == true){
                  this.$refs.prev_page.disabled = false
                  this.$refs.prev_page.style.cursor = 'pointer'
                  this.$refs.prev_page.title = '上一页'
                }
                
                if((this.allFrom + 10) >= this.allList.total){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }else if(this.tabPosition == '编辑'){
            this.editorCount ++
            this.editorFrom = 10*this.editorCount
            var params = {
              from:this.editorFrom,
              size:10,
              type:'编辑'
            }
            _get(urlEditor,params).then(res =>{
              if(res){
                this.editorList = res.data.data
                this.showList = this.editorList
                if(this.$refs.prev_page.disabled == true){
                  this.$refs.prev_page.disabled = false
                  this.$refs.prev_page.style.cursor = 'pointer'
                  this.$refs.prev_page.title = '上一页'
                }
                if((this.editorFrom + 10) >= this.editorList.total){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }else{
            this.reporterCount ++
            this.reporterFrom = 10*this.reporterCount
            var params = {
              from:this.reporterFrom,
              size:10,
              type:'记者'
            }
            _get(urlReporter,params).then(res =>{
              if(res){
                this.reporterList = res.data.data
                this.showList = this.reporterList
                if(this.$refs.prev_page.disabled == true){
                  this.$refs.prev_page.disabled = false
                  this.$refs.prev_page.style.cursor = 'pointer'
                  this.$refs.prev_page.title = '上一页'
                }
                if((this.reporterFrom + 10) >= this.reporterList.total){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
              }
                //console.log(this.nameList)
              }).catch((res)=>{
                console.log(res)
            })
          }
        },
        toPerson(name){
          this.$router.push(
            {
              path: '/editorReporter',
					    query:{index:name,from:0,size:10}
            }
          );
        },
        backPrev(){
          window.history.go(-1);
          setTimeout(()=>{
            this.$router.go(0);
          },20)
        },
        handleBack(){
          if(document.getElementById('app').scrollTop > 100){
            this.$refs.back_prev.style.top = "2%"
          }else{
            this.$refs.back_prev.style.top = "9%"
          }
        },
        getMediaInfo(){
          var id = ''
          if(this.searchType == 'medias'){
            id = this.$route.query.id
          }else{
            id = this.reporterDetail.ssmt.id
          }
          let urlAll = 'medias/'+id+'/reporters'
          let urlEditor = 'medias/'+id+'/type/reporters'
          let urlReporter = 'medias/'+id+'/type/reporters'
          this.$axios.all([
            _get(urlAll,
              {
                from:0,
                size:10
              }
            ),
            _get(urlEditor,
              {
                from:0,
                size:10,
                type:'编辑'
              }
            ),
            _get(urlReporter,
              {
                from:0,
                size:10,
                type:'记者'
              }
            )
          ]).then(res => {
            this.allList = res[0].data.data
            this.editorList = res[1].data.data
            this.reporterList = res[2].data.data
            //console.log(this.allList)
            //console.log(this.editorList)
            //console.log(this.reporterList)
            this.showList = this.allList
            //console.log(this.allList)
            this.$nextTick(function () {
              if(this.searchType == 'medias'){
                if(this.showList.total){
                  this.$refs.prev_page.disabled = 'true'
                  this.$refs.prev_page.style.cursor = 'not-allowed'
                  this.$refs.prev_page.title = '前面没数据了……'
                  if(this.showList.total <= 10){
                    this.$refs.next_page.disabled = 'true'
                    this.$refs.next_page.style.cursor = 'not-allowed'
                    this.$refs.next_page.title = '后面没数据了……'
                  }
                }
              }
            })
          }).catch((res)=>{
            console.log(res)
          });
        },
        getArticleList(){
          let id = this.$route.query.id
          if(this.searchType == 'medias'){
            let url = 'medias/'+id+'/latest/contents'
            _get(url,
                {
                  sort:'desc',
                  from:0,
                  size:10
                }
            ).then((res) => {
                //console.log(res)
                if(res.data.data.dataList){
                  this.dataList = res.data.data.dataList
                }
                //console.log(this.dataList)
            }).catch((res)=>{
              console.log(res)
            })
          }
          else{
            let contenturl = this.searchType + '/' + id + '/latest/contents?'
            //console.log(this.reporterDetail.ssmt.zw)
            _get(contenturl,{
                sort:'desc',
                from:0,
                size:10,
                type:this.reporterDetail.ssmt.zw
            }).then((res)=>{
              //console.log(res)
              if(res.data.data.dataList){
                  this.contentList = res.data.data.dataList
                }
            })
          }
        },
        drawPie() {
          // 基于准备好的dom，初始化echarts实例
          let myChart = []
          let showText = ''
          if(this.searchType=='medias'){
            myChart = echarts.init(document.getElementById('resource_type'));
            showText = '资源类型'
          }else {
            myChart = echarts.init(document.getElementById('rep_resource_type'));
            showText = '稿件类型占比'
          }
          // 绘制图表
          myChart.setOption({
            title : {
              text: showText,
              x:'center',
              y: 'bottom',
              textStyle:{
                color:'#666',
                fontSize: '16'
              }
            },
            tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            series : [
              {
                name: '类型占比',
                type: 'pie',
                radius : '55%',
                center: ['50%', '50%'],
                data:[
                  {value:this.contentDetail.tj.zylx.wz, name:'文章'},
                  {value:this.contentDetail.tj.zylx.tp, name:'图片'},
                  {value:this.contentDetail.tj.zylx.qt, name:'其他'},
                  {value:this.contentDetail.tj.zylx.sp, name:'视频'},
                  {value:this.contentDetail.tj.zylx.yp, name:'音频'},
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  },
                  color: function (params){
                    var colorList = ['#409EFF','#67C23A','#F56C6C','#E6A23C','#6CE7F5'];
                    return colorList[params.dataIndex];
                  },
                }
              }
            ]
          });
        },
        drawBar() {
          // 基于准备好的dom，初始化echarts实例
          let myChart = []
          let showText = ''
          if(this.searchType=='medias'){
            myChart = echarts.init(document.getElementById('spread_channel'));
            showText = '传播渠道'
          }else {
            myChart = echarts.init(document.getElementById('rep_spread_channel'));
            showText = '渠道发布类型'
          }
          myChart.setOption({
            title : {
              text: showText,
              x:'center',
              y: 'bottom',
              textStyle:{
                color:'#666',
                fontSize: '16'
              }
            },
            tooltip:{
              trigger: 'axis',
              axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            xAxis: {
              type: 'category',
              data: ['网站', '微信', 'APP', '手机报'],
              axisTick:{
                show:false
              },
              axisLine:{
                lineStyle:{
                  color:'#ccc',
                  width:4,

                }
              }
            },
            yAxis: {
              type: 'value',
              axisTick:{
                show:false
              },
              axisLabel:{
                show:false
              },
              splitLine:{
                show:false
              },
              axisLine:{
                lineStyle:{
                  color:'#ccc',
                  width:4,

                }
              }
            },
            series: [{
              data: [this.contentDetail.tj.cbqd.wz, this.contentDetail.tj.cbqd.wx, this.contentDetail.tj.cbqd.APP, this.contentDetail.tj.cbqd.sjb],
              type: 'bar',
              //配置样式
              itemStyle: {
                //通常情况下：
                normal:{
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params){
                    var colorList = ['#409EFF','#67C23A','#F56C6C','#E6A23C'];
                    return colorList[params.dataIndex];
                  },
                  label:{
                    show:true,
                    position:'top'
                  },
                  barBorderRadius: [6, 6, 0, 0]

                },

                //鼠标悬停时：
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              //设置柱子的宽度
              barWidth : 50,

            }]
          })
        },
        handlePosition(){
          var list = this.$refs.info_item.children
          if(list && list.length){          
            for(var i = 0;i < list.length-1;i++){
              if(i % 3 == 0){
                list[i].style.display = 'flex'
                list[i].style.justifyContent = 'flex-start'
              }else if(i % 3 == 1){
                list[i].style.display = 'flex'
                list[i].style.justifyContent = 'center'
              }else{
                list[i].style.display = 'flex'
                list[i].style.justifyContent = 'flex-end'
              }
            }
          }
        },
        handleLast() {
          var list = this.$refs.info_item.children
          if(list && list.length){
            var length = list.length         
            if((length % 3) === 0){
              for(var i = length-1;i > length -4;i -- ){
                list[i].style.borderBottom = 'none'
              }
            }
            else if((length % 3) === 1){
                list[length-1].style.borderBottom = 'none'
            }
            else {
              for(var i = length-1;i > length -3;i -- ){
                list[i].style.borderBottom = 'none'
              }
            }
          }
        },
        selectItem(item){
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentsearch/contentDetail",
            query:{id:item.id}
          });
        },
        readMore(){
          if(this.searchType=='reporters'){
            this.$router.push({
              //你需要接受路由的参数再跳转
              path: "/readmore",
              query:{
                id:this.$route.query.id,
                type:this.reporterDetail.ssmt.zw,
                index:this.$route.query.index
              }
          });
          }else {
            this.$router.push({
              //你需要接受路由的参数再跳转
              path: "/readmore",
              query:{id:this.$route.query.id,
                index:this.$route.query.index
                }
            })
          }

        },
        getDetail(id,lx,urls) {
          if(lx.indexOf('视频') > -1){
            this.$router.push({
              //你需要接受路由的参数再跳转
              path: "/contentsearch/contentDetail",
              query:{id:id,url:urls,type:this.type} 
            });
          }
          else{
            this.$router.push({
              //你需要接受路由的参数再跳转
              path: "/contentsearch/contentDetail",
              query:{id:id} 
            });
          }
        },
        toReporter(item){
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/reporters/reportersdetail",
            query:{id:item.id,zw:this.reporterDetail.ssmt.zw} 
          });
          location.reload()
        },
        searchNewWord(newWords,value) {
          //console.log(newWords)
          ///console.log(value)
          switch(value){
            case '1':this.$router.push({//你需要接受路由的参数再跳转
                path: '/contentsearch',
                query:{index:newWords,sort:'desc',from:0,size:10}
            });
            location.reload();
            break;
            case '2':this.$router.push({//你需要接受路由的参数再跳转
                path: '/pressMedia',
                query:{index:newWords,from:0,size:10}
            });
            location.reload();
            break;
            case '3':this.$router.push({//你需要接受路由的参数再跳转
                path: '/editorReporter',
                query:{index:newWords,from:0,size:10}
            });
            location.reload();
            break;
            case '4':this.$router.push({//你需要接受路由的参数再跳转
              path: '/contentName',
              query:{index:newWords,type:'person',sort:'desc',from:0,size:10}
            });
            location.reload();
            break;
            case '5':this.$router.push({//你需要接受路由的参数再跳转
              path: '/contentDepartment',
              query:{index:newWords,type:'organization',sort:'desc',from:0,size:10}
            });
            location.reload();
            break;
            case '6':this.$router.push({//你需要接受路由的参数再跳转
              path: '/contentSites',
              query:{index:newWords,type:'address',sort:'desc',from:0,size:10}
            });
            location.reload();
            break;
          }
          if(this.handleValue === value){
            location.reload()
          }
        },
      },
      watch:{
        tabPosition:function (val) {
          if(val === '全部'){
            this.showList = this.allList
            if(this.allFrom == 0 && this.showList.total){
              this.$refs.prev_page.disabled = 'true'
              this.$refs.prev_page.style.cursor = 'not-allowed'
              this.$refs.prev_page.title = '前面没数据了……'
              if(this.showList.total <= 10){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
            }
            // console.log("allFrom:"+this.allFrom)
            // console.log("allCount:"+this.allCount)
          }else if(val === '编辑'){
            this.showList = this.editorList
            if(this.editorFrom == 0 && this.showList.total){
              this.$refs.prev_page.disabled = 'true'
              this.$refs.prev_page.style.cursor = 'not-allowed'
              this.$refs.prev_page.title = '前面没数据了……'
              if(this.showList.total <= 10){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
            }
            // console.log("editorFrom:"+this.editorFrom)
            // console.log("editorCount:"+this.editorCount)
          }else{
            this.showList = this.reporterList
            if(this.reporterFrom == 0 && this.showList.total){
              this.$refs.prev_page.disabled = 'true'
              this.$refs.prev_page.style.cursor = 'not-allowed'
              this.$refs.prev_page.title = '前面没数据了……'
              if(this.showList.total <= 10){
                  this.$refs.next_page.disabled = 'true'
                  this.$refs.next_page.style.cursor = 'not-allowed'
                  this.$refs.next_page.title = '后面没数据了……'
                }
            }            
            // console.log("reporterFrom:"+this.reporterFrom)
            // console.log("reporterCount:"+this.reporterCount)
          }
        },
        showList:function(oldVal, newVal){
          if(oldVal.dataList != newVal.dataList){
            this.$nextTick(function(){
              if(this.searchType == 'medias'){
                this.handlePosition()
                this.handleLast()
              }
            })
          }
        }
      },
      created(){
      },
      beforeDestroy() {
        document.getElementById('app').removeEventListener('scroll',this.handleBack)
        document.getElementById('app').removeEventListener('scroll',this.handleTop)
      },
      mounted() {
        document.getElementById('app').addEventListener('scroll',this.handleBack)
        document.getElementById('app').addEventListener('scroll',this.handleTop)
        this.$nextTick(()=>{
          if(this.$route.path === '/pressMedia/pressmediadetail'){
            this.searchType = 'medias'
            this.getContentDetail()
          }
          else{
            this.searchType = 'reporters'
            this.getContentDetail()
          }
        })
      }
    }
</script>

<style>
  .press_media_detail{
    width: 1200px;
    margin: 20px auto;
  }
  .content_source{
    height: 120px;
    width: 100%;
    padding: 30px 20px;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .detail_content{
    width: 904px;
    float: left;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius:6px 0px 0px 6px;
    margin-bottom: 20px;
  }
  .source_desc{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .desc_top{
    display: flex;
    justify-content: flex-start;
    color: #333;
    align-items: center;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .rep_desc_top{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #333;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .rep_info_img img{
    width: 40px;
    height: 40px;
  }
  .rep_info_img{
    width: 40px;
    height: 40px;
  }
  .rep_info_name{
    margin-left: 18px;
    color: #333;
  }
  .rep_info_role{
    margin-left: 18px;
    color: #666;
  }
  .source_img{
    margin-left: 40px;
  }
  .desc_media img{
    width: 12px;
    height: 12px;
  }
  .attach_info{
    width: 280px;
    float: right;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius:0px 6px 0px 0px;
  }
  .attach_reporter{
    margin-left: 20px;
    cursor: pointer;
  }
  .source_number{
    padding-left: 15px;
    padding-right: 15px;
    height: 50px;
    color: #fff;
    float: right;
    letter-spacing: 2px;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    background:rgba(61,118,255,1);
    box-shadow:0px 3px 7px 0px rgba(48,96,213,1);
    border-radius:4px;
  }
  .source_number span{
    font-size: 18px;
  }
  .source_img img{
    height: 38px;
  }
  .desc_media{
    color: #666;
    font-size: 12px;
  }
  .media_address span{
    color: #999999;
  }
  .media_type{
    margin-left: 40px;
  }
  .media_type span{
    color: #999999;
  }
  .chart{
    display: flex;
    justify-content: space-between;
  }
  .resource_type{
    width: 55%;
    height: 240px;
    box-sizing: border-box;
  }
  .spread_channel{
    width: 40%;
    height: 240px;
    box-sizing: border-box;
  }
  .incumbent{
    width: 864px;
    margin: 20px auto;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius:6px;
  }
  .incumbent_number{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius:6px 6px 0px 0px;
  }
  .incumbent_text{
    font-size: 18px;
    color: #333;
    width:80px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .btn_media_group .el-radio-group {
    box-sizing: border-box;
  }
  .btn_media_group .el-radio-button:first-child .el-radio-button__inner{
    border-radius: 6px 0 0 0;
  }
  .btn_media_group .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 6px 0 0;
  }
  .info_item{
    width: 275px;
    display: inline-flex;
    justify-content: flex-start;
    cursor: pointer;
    height: 82px;
    box-sizing: border-box;
    padding: 20px 0;
    border-bottom: 1px dashed #ccc;
  }
  .info_img{
    width:40px;
    height:40px;
  }
  .info_img img{
    width: 40px;
    height:40px;
    border-radius: 20px;
  }
  .info_content{
    margin-left: 15px;
    line-height: 20px;
  }
  .incumbent_info{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 827px;
    margin: 0 20px;
  }
  .info_name{
    font-size: 16px;
    color: #333333;
  }
  .info_role{
    font-size: 14px;
    color: #666;
  }
  .noData{
    width: 100%;
    height: 82px;
    box-sizing: border-box;
    text-align: center;
    padding: 35px;
  }
  .latest_article{
    width: 864px;
    margin: 20px auto;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius:6px;
  }
  .article_text{
    float: left;
    font-size: 18px;
    color: #333;
    margin-left: 20px;
    margin-top: 10px;
  }
  .article_more{
    float: right;
    font-size: 14px;
    color: #999;
    margin-right: 20px;
    margin-top: 13px;
    cursor: pointer;
  }
  .article_desc{
    width: 100%;
    height: 40px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius:6px 6px 0px 0px;
  }
  .article_list{
    margin: 10px 20px;
  }
  .attach_text{
    box-sizing: border-box;
    height:40px;
    padding: 10px 0 10px 20px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius:6px 6px 0px 0px;
  }
  .attach_text span{
    font-size: 18px;
    color: #333333;
  }
  .attach_item{
    height: 120px;
    margin: 20px 10px 0 10px;
    border-bottom:1px dashed rgba(204,204,204,1);
    padding-bottom: 15px;
  }
  .attach_item:last-child{
    border-bottom:none;
  }
  .attach_desc{
    margin: 20px 10px;
    display: flex;
    justify-content: flex-start;
  }
  .attach_desc_text{
    font-size:16px;
    font-family:思源黑体;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:16px;
  }
  .attach_img img{
    height: 23px;
    margin-left: 36px;
  }
  .attach_link{
    margin: 18px 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .link_img img{
    height: 24px;
    width: 24px;
  }
  .link_img{
    height: 24px;
    width: 24px;
  }
  .link_address{
    height: 20px;
    width: 200px;
    margin-left: 20px;
    font-size:18px;
    font-family:思源黑体;
    font-weight:400;
    color:rgba(102,102,102,1);
    cursor: pointer;
    line-height:16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .link_address a{
    color:rgba(102,102,102,1);
    text-decoration: none;
  }
  .address{
    width: 200px;
    margin-left: 20px;
    font-size:14px;
    font-family:思源黑体;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:16px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .attach_info {
    width: 280px;
    margin-bottom: 20px;
    float: right;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 6px 0px 0px;
  }
  .attach_text {
    box-sizing: border-box;
    height: 40px;
    padding: 10px 0 10px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 0px 0px;
  }
  .attach_text span {
    font-size: 18px;
    color: #333333;
  }
  .attach_item {
    height: 120px;
    margin: 20px 10px;
  }
  .attach_link_info{
    margin: 20px 20px 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px dashed #eee;
  }
  .rep_info_content{
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .back_prev{
    position: fixed;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 6;
    font-size: 14px;
    top: 9%;
    left: 2%;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    background-color: #00C2FF;
  }
  .back_prev:hover{
    background-color: #3D76FF
  }
  .back_prev img{
    height: 20px;
    width: 20px
  }
  .btn_page{
    background: #fff;
    border: 1px solid #ccc;
    font-size: 12px;
    cursor: pointer;
  }
  .btn_page:first-child{
    margin-top: 20px;
    margin-left: 108px;
  }
  .search_page{
    width: 265px;
  }
  .totop_icon{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  background-color: #CCC;
  border-radius: 3px;
  position: fixed;
  bottom: 9%;
  right: 12%;
  cursor: pointer;
}
.totop_icon:hover{
  background-color: #999999;
}
.totop_icon img{
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pressMediaDetail.vue